import { Box } from "@chakra-ui/react"

export const GameInfo = (props) => {
    return (
        <Box bg='gray.200' h='200px'>

        </Box>
    )
}